module.exports = __webpack_public_path__ + "static/media/qrcode.321ba9c7.svg";